import { Empty, Spin, Typography } from "antd";
import useHeatMap from "../hooks/useHeatMap";

const { Text } = Typography;
function VerifyHeatMap({ selectedDate, isLastRecordPending }) {
  const { data: heatmapData, isLoading } = useHeatMap({
    selectedDate,
    isLastRecordPending,
  });

  if (isLoading || isLastRecordPending) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
          height: "100%",
          marginTop: "100px",
        }}>
        <Spin />
      </div>
    );
  }

  if (!heatmapData) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<span>Não há informações disponíveis no momento.</span>}
      />
    );
  }

  return (
    <>
      <img src={heatmapData} alt="Heatmap" style={{ width: "100%" }} />
      <Text strong style={{ fontSize: "15px", marginTop: "15px" }}>
        OBS: essa imagem diz respeito a um dia inteiro de detecções
      </Text>
    </>
  );
}

export default VerifyHeatMap;
